import { render, staticRenderFns } from "./OpenCartOrders.vue?vue&type=template&id=da2b8ae8&scoped=true&"
import script from "./OpenCartOrders.vue?vue&type=script&lang=js&"
export * from "./OpenCartOrders.vue?vue&type=script&lang=js&"
import style0 from "./OpenCartOrders.vue?vue&type=style&index=0&id=da2b8ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2b8ae8",
  null
  
)

component.options.__file = "OpenCartOrders.vue"
export default component.exports